
import { Button } from "@/components/ui/button";
import { Shield, RefreshCw, Settings, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface AdminHeaderProps {
  onRefresh: () => void;
  isLoading: boolean;
  onSyncStripe: () => void;
  isSyncing: boolean;
}

export default function AdminHeader({ 
  onRefresh, 
  isLoading, 
  onSyncStripe, 
  isSyncing 
}: AdminHeaderProps) {
  const navigate = useNavigate();
  return (
    <div className="flex justify-between items-center mb-8">
      <div>
        <h1 className="text-3xl font-bold font-display tracking-tight flex items-center gap-2">
          <Shield className="h-8 w-8 text-primary" /> Admin Dashboard
        </h1>
        <p className="text-muted-foreground mt-1">
          Manage users and their permissions
        </p>
      </div>
      
      <div className="flex items-center gap-2">
        <Button 
          variant="outline"
          onClick={() => navigate('/')}
          className="flex items-center gap-2"
          aria-label="Back to home page"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </Button>
        
        <Button 
          variant="outline"
          onClick={onSyncStripe}
          disabled={isSyncing}
          className="flex items-center gap-2"
        >
          <Settings className="h-4 w-4" />
          {isSyncing ? "Syncing..." : "Sync Stripe"}
        </Button>
        
        <Button 
          variant="outline" 
          onClick={onRefresh}
          disabled={isLoading}
          className="flex items-center gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Refresh
        </Button>
      </div>
    </div>
  );
}
